// extracted by mini-css-extract-plugin
export default {"container":"Checkoutpage_container__82A9B","details":"Checkoutpage_details__1n+fM","checklabel":"Checkoutpage_checklabel__44j70","delivery":"Checkoutpage_delivery__mMSHK"};